var _text, _text2, _text3, _text4, _text5, _text6, _text7, _text8, _text9, _text10, _text11, _text12, _text13, _text14, _text15, _text16, _text17, _text18, _text19, _text20, _text21, _text22, _text23, _text24, _text25, _text26, _text27, _text28, _text29, _text30, _text31, _text32, _text33, _text34, _text35, _text36, _text37, _text38, _text39, _text40, _text41, _text42, _text43, _text44, _text45, _text46, _text47, _text48, _text49, _text50, _text51, _text52, _text53, _text54, _text55, _text56, _text57, _text58, _text59, _text60, _text61, _text62, _text63, _text64, _text65, _text66, _text67, _text68, _text69, _text70, _text71, _text72, _text73, _text74, _text75, _text76, _text77, _text78, _text79, _text80, _text81, _text82, _text83, _text84, _text85, _text86, _text87, _text88, _text89, _text90, _text91, _text92, _text93, _text94, _text95, _text96, _text97, _text98, _text99, _text100, _text101, _text102, _text103, _text104, _text105, _text106, _text107, _text108, _text109, _text110, _text111, _text112, _text113, _text114, _text115, _text116, _text117, _text118, _text119, _text120, _text121, _text122, _text123, _text124, _text125, _text126, _text127, _text128, _text129, _text130, _text131, _text132, _text133, _text134, _text135, _text136, _text137, _text138, _text139, _text140, _text141, _text142, _text143, _text144, _text145, _text146, _text147, _text148, _text149, _text150, _g, _text151, _text152, _text153, _text154, _text155, _text156, _text157, _text158, _text159, _text160, _text161, _text162, _text163, _text164, _text165, _text166, _text167, _text168, _text169, _text170, _text171, _text172, _text173, _text174, _text175, _text176, _text177, _text178, _text179, _text180, _text181, _text182, _text183, _text184, _text185, _text186, _text187, _text188, _text189, _text190, _text191, _text192, _text193, _text194, _text195, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRstudio(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 729.64,
    y: 231.36
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 729.64,
    y: 231.36
  }))), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    transform: "scale(4.0128 .2492)",
    x: 378.91,
    y: 579.26
  })), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 1310.91,
    y: 151.36
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 1310.91,
    y: 151.36
  }))), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    transform: "scale(4.0128 .2492)",
    x: 523.76,
    y: 258.22
  })), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 239.33,
    y: -29.9
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 239.33,
    y: -29.9
  }))), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    transform: "scale(4.0128 .2492)",
    x: 256.72,
    y: -469.13
  })), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    x: 1337.38,
    y: -246.37
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 1337.38,
    y: -246.37
  }))), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    transform: "scale(4.0128 .2492)",
    x: 530.36,
    y: -1337.8
  })), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    x: 1918.65,
    y: -326.37
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 1918.65,
    y: -326.37
  }))), _text10 || (_text10 = /*#__PURE__*/React.createElement("text", {
    transform: "scale(4.0128 .2492)",
    x: 675.21,
    y: -1658.83
  })), _text11 || (_text11 = /*#__PURE__*/React.createElement("text", {
    x: 1529.53,
    y: -798.77
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 1529.53,
    y: -798.77
  }))), _text12 || (_text12 = /*#__PURE__*/React.createElement("text", {
    transform: "scale(4.0128 .2492)",
    x: 578.24,
    y: -3554.48
  })), _text13 || (_text13 = /*#__PURE__*/React.createElement("text", {
    x: 2110.79,
    y: -878.78
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 2110.79,
    y: -878.78
  }))), _text14 || (_text14 = /*#__PURE__*/React.createElement("text", {
    transform: "scale(4.0128 .2492)",
    x: 723.09,
    y: -3875.52
  })), _text15 || (_text15 = /*#__PURE__*/React.createElement("text", {
    x: 277.99,
    y: 535.94
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 277.99,
    y: 535.94
  }))), _text16 || (_text16 = /*#__PURE__*/React.createElement("text", {
    x: 729.64,
    y: 231.36
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 729.64,
    y: 231.36
  }))), _text17 || (_text17 = /*#__PURE__*/React.createElement("text", {
    transform: "scale(4.0128 .2492)",
    x: 378.91,
    y: 579.26
  })), _text18 || (_text18 = /*#__PURE__*/React.createElement("text", {
    x: 1310.91,
    y: 151.36
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 1310.91,
    y: 151.36
  }))), _text19 || (_text19 = /*#__PURE__*/React.createElement("text", {
    transform: "scale(4.0128 .2492)",
    x: 523.76,
    y: 258.22
  })), _text20 || (_text20 = /*#__PURE__*/React.createElement("text", {
    x: 239.33,
    y: -29.9
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 239.33,
    y: -29.9
  }))), _text21 || (_text21 = /*#__PURE__*/React.createElement("text", {
    transform: "scale(4.0128 .2492)",
    x: 256.72,
    y: -469.13
  })), _text22 || (_text22 = /*#__PURE__*/React.createElement("text", {
    x: 1337.38,
    y: -246.37
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 1337.38,
    y: -246.37
  }))), _text23 || (_text23 = /*#__PURE__*/React.createElement("text", {
    transform: "scale(4.0128 .2492)",
    x: 530.36,
    y: -1337.8
  })), _text24 || (_text24 = /*#__PURE__*/React.createElement("text", {
    x: 1918.65,
    y: -326.37
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 1918.65,
    y: -326.37
  }))), _text25 || (_text25 = /*#__PURE__*/React.createElement("text", {
    transform: "scale(4.0128 .2492)",
    x: 675.21,
    y: -1658.83
  })), _text26 || (_text26 = /*#__PURE__*/React.createElement("text", {
    x: 1529.53,
    y: -798.77
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 1529.53,
    y: -798.77
  }))), _text27 || (_text27 = /*#__PURE__*/React.createElement("text", {
    transform: "scale(4.0128 .2492)",
    x: 578.24,
    y: -3554.48
  })), _text28 || (_text28 = /*#__PURE__*/React.createElement("text", {
    x: 2110.79,
    y: -878.78
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 2110.79,
    y: -878.78
  }))), _text29 || (_text29 = /*#__PURE__*/React.createElement("text", {
    transform: "scale(4.0128 .2492)",
    x: 723.09,
    y: -3875.52
  })), _text30 || (_text30 = /*#__PURE__*/React.createElement("text", {
    x: 277.99,
    y: 535.94
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 277.99,
    y: 535.94
  }))), _text31 || (_text31 = /*#__PURE__*/React.createElement("text", {
    x: 729.64,
    y: 231.36
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 729.64,
    y: 231.36
  }))), _text32 || (_text32 = /*#__PURE__*/React.createElement("text", {
    transform: "scale(4.0128 .2492)",
    x: 378.91,
    y: 579.26
  })), _text33 || (_text33 = /*#__PURE__*/React.createElement("text", {
    x: 1310.91,
    y: 151.36
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 1310.91,
    y: 151.36
  }))), _text34 || (_text34 = /*#__PURE__*/React.createElement("text", {
    transform: "scale(4.0128 .2492)",
    x: 523.76,
    y: 258.22
  })), _text35 || (_text35 = /*#__PURE__*/React.createElement("text", {
    x: 239.33,
    y: -29.9
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 239.33,
    y: -29.9
  }))), _text36 || (_text36 = /*#__PURE__*/React.createElement("text", {
    transform: "scale(4.0128 .2492)",
    x: 256.72,
    y: -469.13
  })), _text37 || (_text37 = /*#__PURE__*/React.createElement("text", {
    x: 1337.38,
    y: -246.37
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 1337.38,
    y: -246.37
  }))), _text38 || (_text38 = /*#__PURE__*/React.createElement("text", {
    transform: "scale(4.0128 .2492)",
    x: 530.36,
    y: -1337.8
  })), _text39 || (_text39 = /*#__PURE__*/React.createElement("text", {
    x: 1918.65,
    y: -326.37
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 1918.65,
    y: -326.37
  }))), _text40 || (_text40 = /*#__PURE__*/React.createElement("text", {
    transform: "scale(4.0128 .2492)",
    x: 675.21,
    y: -1658.83
  })), _text41 || (_text41 = /*#__PURE__*/React.createElement("text", {
    x: 1529.53,
    y: -798.77
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 1529.53,
    y: -798.77
  }))), _text42 || (_text42 = /*#__PURE__*/React.createElement("text", {
    transform: "scale(4.0128 .2492)",
    x: 578.24,
    y: -3554.48
  })), _text43 || (_text43 = /*#__PURE__*/React.createElement("text", {
    x: 2110.79,
    y: -878.78
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 2110.79,
    y: -878.78
  }))), _text44 || (_text44 = /*#__PURE__*/React.createElement("text", {
    transform: "scale(4.0128 .2492)",
    x: 723.09,
    y: -3875.52
  })), _text45 || (_text45 = /*#__PURE__*/React.createElement("text", {
    x: 277.99,
    y: 535.94
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 277.99,
    y: 535.94
  }))), _text46 || (_text46 = /*#__PURE__*/React.createElement("text", {
    x: 13.421,
    y: 260.32
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 13.421,
    y: 260.32
  }))), _text47 || (_text47 = /*#__PURE__*/React.createElement("text", {
    transform: "scale(4.0128 .2492)",
    x: 200.43,
    y: 695.45
  })), _text48 || (_text48 = /*#__PURE__*/React.createElement("text", {
    x: 594.69,
    y: 180.32
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 594.69,
    y: 180.32
  }))), _text49 || (_text49 = /*#__PURE__*/React.createElement("text", {
    transform: "scale(4.0128 .2492)",
    x: 345.27,
    y: 374.43
  })), _text50 || (_text50 = /*#__PURE__*/React.createElement("text", {
    x: -476.89,
    y: -0.942
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -476.89,
    y: -0.942
  }))), _text51 || (_text51 = /*#__PURE__*/React.createElement("text", {
    transform: "scale(4.0128 .2492)",
    x: 78.24,
    y: -352.93
  })), _text52 || (_text52 = /*#__PURE__*/React.createElement("text", {
    x: 621.16,
    y: -217.41
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 621.16,
    y: -217.41
  }))), _text53 || (_text53 = /*#__PURE__*/React.createElement("text", {
    transform: "scale(4.0128 .2492)",
    x: 351.87,
    y: -1221.6
  })), _text54 || (_text54 = /*#__PURE__*/React.createElement("text", {
    x: 1202.43,
    y: -297.42
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 1202.43,
    y: -297.42
  }))), _text55 || (_text55 = /*#__PURE__*/React.createElement("text", {
    transform: "scale(4.0128 .2492)",
    x: 496.72,
    y: -1542.63
  })), _text56 || (_text56 = /*#__PURE__*/React.createElement("text", {
    x: 813.31,
    y: -769.82
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 813.31,
    y: -769.82
  }))), _text57 || (_text57 = /*#__PURE__*/React.createElement("text", {
    transform: "scale(4.0128 .2492)",
    x: 399.75,
    y: -3438.29
  })), _text58 || (_text58 = /*#__PURE__*/React.createElement("text", {
    x: 1394.57,
    y: -849.82
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 1394.57,
    y: -849.82
  }))), _text59 || (_text59 = /*#__PURE__*/React.createElement("text", {
    transform: "scale(4.0128 .2492)",
    x: 544.6,
    y: -3759.31
  })), _text60 || (_text60 = /*#__PURE__*/React.createElement("text", {
    x: -438.23,
    y: 564.9
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -438.23,
    y: 564.9
  }))), _text61 || (_text61 = /*#__PURE__*/React.createElement("text", {
    x: 13.421,
    y: 260.32
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 13.421,
    y: 260.32
  }))), _text62 || (_text62 = /*#__PURE__*/React.createElement("text", {
    transform: "scale(4.0128 .2492)",
    x: 200.43,
    y: 695.45
  })), _text63 || (_text63 = /*#__PURE__*/React.createElement("text", {
    x: 594.69,
    y: 180.32
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 594.69,
    y: 180.32
  }))), _text64 || (_text64 = /*#__PURE__*/React.createElement("text", {
    transform: "scale(4.0128 .2492)",
    x: 345.27,
    y: 374.43
  })), _text65 || (_text65 = /*#__PURE__*/React.createElement("text", {
    x: -476.89,
    y: -0.942
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -476.89,
    y: -0.942
  }))), _text66 || (_text66 = /*#__PURE__*/React.createElement("text", {
    transform: "scale(4.0128 .2492)",
    x: 78.24,
    y: -352.93
  })), _text67 || (_text67 = /*#__PURE__*/React.createElement("text", {
    x: 621.16,
    y: -217.41
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 621.16,
    y: -217.41
  }))), _text68 || (_text68 = /*#__PURE__*/React.createElement("text", {
    transform: "scale(4.0128 .2492)",
    x: 351.87,
    y: -1221.59
  })), _text69 || (_text69 = /*#__PURE__*/React.createElement("text", {
    x: 1202.43,
    y: -297.42
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 1202.43,
    y: -297.42
  }))), _text70 || (_text70 = /*#__PURE__*/React.createElement("text", {
    transform: "scale(4.0128 .2492)",
    x: 496.72,
    y: -1542.62
  })), _text71 || (_text71 = /*#__PURE__*/React.createElement("text", {
    x: 813.31,
    y: -769.82
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 813.31,
    y: -769.82
  }))), _text72 || (_text72 = /*#__PURE__*/React.createElement("text", {
    transform: "scale(4.0128 .2492)",
    x: 399.75,
    y: -3438.27
  })), _text73 || (_text73 = /*#__PURE__*/React.createElement("text", {
    x: 1394.57,
    y: -849.82
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 1394.57,
    y: -849.82
  }))), _text74 || (_text74 = /*#__PURE__*/React.createElement("text", {
    transform: "scale(4.0128 .2492)",
    x: 544.6,
    y: -3759.29
  })), _text75 || (_text75 = /*#__PURE__*/React.createElement("text", {
    x: -438.23,
    y: 564.9
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -438.23,
    y: 564.9
  }))), _text76 || (_text76 = /*#__PURE__*/React.createElement("text", {
    x: 729.64,
    y: 231.36
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 729.64,
    y: 231.36
  }))), _text77 || (_text77 = /*#__PURE__*/React.createElement("text", {
    transform: "scale(4.0128 .2492)",
    x: 378.91,
    y: 579.26
  })), _text78 || (_text78 = /*#__PURE__*/React.createElement("text", {
    x: 1310.91,
    y: 151.36
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 1310.91,
    y: 151.36
  }))), _text79 || (_text79 = /*#__PURE__*/React.createElement("text", {
    transform: "scale(4.0128 .2492)",
    x: 523.76,
    y: 258.22
  })), _text80 || (_text80 = /*#__PURE__*/React.createElement("text", {
    x: 239.33,
    y: -29.9
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 239.33,
    y: -29.9
  }))), _text81 || (_text81 = /*#__PURE__*/React.createElement("text", {
    transform: "scale(4.0128 .2492)",
    x: 256.72,
    y: -469.13
  })), _text82 || (_text82 = /*#__PURE__*/React.createElement("text", {
    x: 1337.38,
    y: -246.37
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 1337.38,
    y: -246.37
  }))), _text83 || (_text83 = /*#__PURE__*/React.createElement("text", {
    transform: "scale(4.0128 .2492)",
    x: 530.36,
    y: -1337.79
  })), _text84 || (_text84 = /*#__PURE__*/React.createElement("text", {
    x: 1918.65,
    y: -326.37
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 1918.65,
    y: -326.37
  }))), _text85 || (_text85 = /*#__PURE__*/React.createElement("text", {
    transform: "scale(4.0128 .2492)",
    x: 675.21,
    y: -1658.82
  })), _text86 || (_text86 = /*#__PURE__*/React.createElement("text", {
    x: 1529.53,
    y: -798.77
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 1529.53,
    y: -798.77
  }))), _text87 || (_text87 = /*#__PURE__*/React.createElement("text", {
    transform: "scale(4.0128 .2492)",
    x: 578.24,
    y: -3554.46
  })), _text88 || (_text88 = /*#__PURE__*/React.createElement("text", {
    x: 2110.79,
    y: -878.78
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 2110.79,
    y: -878.78
  }))), _text89 || (_text89 = /*#__PURE__*/React.createElement("text", {
    transform: "scale(4.0128 .2492)",
    x: 723.09,
    y: -3875.5
  })), _text90 || (_text90 = /*#__PURE__*/React.createElement("text", {
    x: 277.99,
    y: 535.94
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 277.99,
    y: 535.94
  }))), _text91 || (_text91 = /*#__PURE__*/React.createElement("text", {
    x: 729.64,
    y: 231.36
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 729.64,
    y: 231.36
  }))), _text92 || (_text92 = /*#__PURE__*/React.createElement("text", {
    transform: "scale(4.0128 .2492)",
    x: 378.91,
    y: 579.26
  })), _text93 || (_text93 = /*#__PURE__*/React.createElement("text", {
    x: 1310.91,
    y: 151.36
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 1310.91,
    y: 151.36
  }))), _text94 || (_text94 = /*#__PURE__*/React.createElement("text", {
    transform: "scale(4.0128 .2492)",
    x: 523.76,
    y: 258.22
  })), _text95 || (_text95 = /*#__PURE__*/React.createElement("text", {
    x: 239.33,
    y: -29.9
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 239.33,
    y: -29.9
  }))), _text96 || (_text96 = /*#__PURE__*/React.createElement("text", {
    transform: "scale(4.0128 .2492)",
    x: 256.72,
    y: -469.13
  })), _text97 || (_text97 = /*#__PURE__*/React.createElement("text", {
    x: 1337.38,
    y: -246.37
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 1337.38,
    y: -246.37
  }))), _text98 || (_text98 = /*#__PURE__*/React.createElement("text", {
    transform: "scale(4.0128 .2492)",
    x: 530.36,
    y: -1337.8
  })), _text99 || (_text99 = /*#__PURE__*/React.createElement("text", {
    x: 1918.65,
    y: -326.37
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 1918.65,
    y: -326.37
  }))), _text100 || (_text100 = /*#__PURE__*/React.createElement("text", {
    transform: "scale(4.0128 .2492)",
    x: 675.21,
    y: -1658.83
  })), _text101 || (_text101 = /*#__PURE__*/React.createElement("text", {
    x: 1529.53,
    y: -798.77
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 1529.53,
    y: -798.77
  }))), _text102 || (_text102 = /*#__PURE__*/React.createElement("text", {
    transform: "scale(4.0128 .2492)",
    x: 578.24,
    y: -3554.48
  })), _text103 || (_text103 = /*#__PURE__*/React.createElement("text", {
    x: 2110.79,
    y: -878.78
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 2110.79,
    y: -878.78
  }))), _text104 || (_text104 = /*#__PURE__*/React.createElement("text", {
    transform: "scale(4.0128 .2492)",
    x: 723.09,
    y: -3875.52
  })), _text105 || (_text105 = /*#__PURE__*/React.createElement("text", {
    x: 277.99,
    y: 535.94
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 277.99,
    y: 535.94
  }))), _text106 || (_text106 = /*#__PURE__*/React.createElement("text", {
    x: 729.64,
    y: 231.36
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 729.64,
    y: 231.36
  }))), _text107 || (_text107 = /*#__PURE__*/React.createElement("text", {
    transform: "scale(4.0128 .2492)",
    x: 378.91,
    y: 579.26
  })), _text108 || (_text108 = /*#__PURE__*/React.createElement("text", {
    x: 1310.91,
    y: 151.36
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 1310.91,
    y: 151.36
  }))), _text109 || (_text109 = /*#__PURE__*/React.createElement("text", {
    transform: "scale(4.0128 .2492)",
    x: 523.76,
    y: 258.22
  })), _text110 || (_text110 = /*#__PURE__*/React.createElement("text", {
    x: 239.33,
    y: -29.9
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 239.33,
    y: -29.9
  }))), _text111 || (_text111 = /*#__PURE__*/React.createElement("text", {
    transform: "scale(4.0128 .2492)",
    x: 256.72,
    y: -469.13
  })), _text112 || (_text112 = /*#__PURE__*/React.createElement("text", {
    x: 1337.38,
    y: -246.37
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 1337.38,
    y: -246.37
  }))), _text113 || (_text113 = /*#__PURE__*/React.createElement("text", {
    transform: "scale(4.0128 .2492)",
    x: 530.36,
    y: -1337.8
  })), _text114 || (_text114 = /*#__PURE__*/React.createElement("text", {
    x: 1918.65,
    y: -326.37
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 1918.65,
    y: -326.37
  }))), _text115 || (_text115 = /*#__PURE__*/React.createElement("text", {
    transform: "scale(4.0128 .2492)",
    x: 675.21,
    y: -1658.83
  })), _text116 || (_text116 = /*#__PURE__*/React.createElement("text", {
    x: 1529.53,
    y: -798.77
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 1529.53,
    y: -798.77
  }))), _text117 || (_text117 = /*#__PURE__*/React.createElement("text", {
    transform: "scale(4.0128 .2492)",
    x: 578.24,
    y: -3554.48
  })), _text118 || (_text118 = /*#__PURE__*/React.createElement("text", {
    x: 2110.79,
    y: -878.78
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 2110.79,
    y: -878.78
  }))), _text119 || (_text119 = /*#__PURE__*/React.createElement("text", {
    transform: "scale(4.0128 .2492)",
    x: 723.09,
    y: -3875.52
  })), _text120 || (_text120 = /*#__PURE__*/React.createElement("text", {
    x: 277.99,
    y: 535.94
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 277.99,
    y: 535.94
  }))), _text121 || (_text121 = /*#__PURE__*/React.createElement("text", {
    x: 13.421,
    y: 260.32
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 13.421,
    y: 260.32
  }))), _text122 || (_text122 = /*#__PURE__*/React.createElement("text", {
    transform: "scale(4.0128 .2492)",
    x: 200.43,
    y: 695.45
  })), _text123 || (_text123 = /*#__PURE__*/React.createElement("text", {
    x: 594.69,
    y: 180.32
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 594.69,
    y: 180.32
  }))), _text124 || (_text124 = /*#__PURE__*/React.createElement("text", {
    transform: "scale(4.0128 .2492)",
    x: 345.27,
    y: 374.43
  })), _text125 || (_text125 = /*#__PURE__*/React.createElement("text", {
    x: -476.89,
    y: -0.942
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -476.89,
    y: -0.942
  }))), _text126 || (_text126 = /*#__PURE__*/React.createElement("text", {
    transform: "scale(4.0128 .2492)",
    x: 78.24,
    y: -352.93
  })), _text127 || (_text127 = /*#__PURE__*/React.createElement("text", {
    x: 621.16,
    y: -217.41
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 621.16,
    y: -217.41
  }))), _text128 || (_text128 = /*#__PURE__*/React.createElement("text", {
    transform: "scale(4.0128 .2492)",
    x: 351.87,
    y: -1221.6
  })), _text129 || (_text129 = /*#__PURE__*/React.createElement("text", {
    x: 1202.43,
    y: -297.42
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 1202.43,
    y: -297.42
  }))), _text130 || (_text130 = /*#__PURE__*/React.createElement("text", {
    transform: "scale(4.0128 .2492)",
    x: 496.72,
    y: -1542.63
  })), _text131 || (_text131 = /*#__PURE__*/React.createElement("text", {
    x: 813.31,
    y: -769.82
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 813.31,
    y: -769.82
  }))), _text132 || (_text132 = /*#__PURE__*/React.createElement("text", {
    transform: "scale(4.0128 .2492)",
    x: 399.75,
    y: -3438.29
  })), _text133 || (_text133 = /*#__PURE__*/React.createElement("text", {
    x: 1394.57,
    y: -849.82
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 1394.57,
    y: -849.82
  }))), _text134 || (_text134 = /*#__PURE__*/React.createElement("text", {
    transform: "scale(4.0128 .2492)",
    x: 544.6,
    y: -3759.31
  })), _text135 || (_text135 = /*#__PURE__*/React.createElement("text", {
    x: -438.23,
    y: 564.9
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -438.23,
    y: 564.9
  }))), _text136 || (_text136 = /*#__PURE__*/React.createElement("text", {
    x: 13.421,
    y: 260.32
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 13.421,
    y: 260.32
  }))), _text137 || (_text137 = /*#__PURE__*/React.createElement("text", {
    transform: "scale(4.0128 .2492)",
    x: 200.43,
    y: 695.45
  })), _text138 || (_text138 = /*#__PURE__*/React.createElement("text", {
    x: 594.69,
    y: 180.32
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 594.69,
    y: 180.32
  }))), _text139 || (_text139 = /*#__PURE__*/React.createElement("text", {
    transform: "scale(4.0128 .2492)",
    x: 345.27,
    y: 374.43
  })), _text140 || (_text140 = /*#__PURE__*/React.createElement("text", {
    x: -476.89,
    y: -0.942
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -476.89,
    y: -0.942
  }))), _text141 || (_text141 = /*#__PURE__*/React.createElement("text", {
    transform: "scale(4.0128 .2492)",
    x: 78.24,
    y: -352.93
  })), _text142 || (_text142 = /*#__PURE__*/React.createElement("text", {
    x: 621.16,
    y: -217.41
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 621.16,
    y: -217.41
  }))), _text143 || (_text143 = /*#__PURE__*/React.createElement("text", {
    transform: "scale(4.0128 .2492)",
    x: 351.87,
    y: -1221.59
  })), _text144 || (_text144 = /*#__PURE__*/React.createElement("text", {
    x: 1202.43,
    y: -297.42
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 1202.43,
    y: -297.42
  }))), _text145 || (_text145 = /*#__PURE__*/React.createElement("text", {
    transform: "scale(4.0128 .2492)",
    x: 496.72,
    y: -1542.62
  })), _text146 || (_text146 = /*#__PURE__*/React.createElement("text", {
    x: 813.31,
    y: -769.82
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 813.31,
    y: -769.82
  }))), _text147 || (_text147 = /*#__PURE__*/React.createElement("text", {
    transform: "scale(4.0128 .2492)",
    x: 399.75,
    y: -3438.27
  })), _text148 || (_text148 = /*#__PURE__*/React.createElement("text", {
    x: 1394.57,
    y: -849.82
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 1394.57,
    y: -849.82
  }))), _text149 || (_text149 = /*#__PURE__*/React.createElement("text", {
    transform: "scale(4.0128 .2492)",
    x: 544.6,
    y: -3759.29
  })), _text150 || (_text150 = /*#__PURE__*/React.createElement("text", {
    x: -438.23,
    y: 564.9
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -438.23,
    y: 564.9
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m471.95 253.05c0 120.9-98.01 218.91-218.91 218.91s-218.91-98.01-218.91-218.91 98.01-218.91 218.91-218.91 218.91 98.01 218.91 218.91",
    fill: "#3976c4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m256 1c-140.83 0-255 114.17-255 255s114.17 255 255 255 255-114.17 255-255-114.17-255-255-255m8.827 44.931c120.9 0 218.9 98 218.9 218.9s-98 218.9-218.9 218.9-218.93-98-218.93-218.9 98.03-218.9 218.93-218.9",
    fillOpacity: 0.067
  }), /*#__PURE__*/React.createElement("g", {
    fillOpacity: 0.129
  }, /*#__PURE__*/React.createElement("path", {
    d: "m256 4.43c-138.94 0-251.57 112.63-251.57 251.57s112.63 251.57 251.57 251.57 251.57-112.63 251.57-251.57-112.63-251.57-251.57-251.57m5.885 38.556c120.9 0 218.9 98 218.9 218.9s-98 218.9-218.9 218.9-218.93-98-218.93-218.9 98.03-218.9 218.93-218.9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m256 8.36c-136.77 0-247.64 110.87-247.64 247.64s110.87 247.64 247.64 247.64 247.64-110.87 247.64-247.64-110.87-247.64-247.64-247.64m2.942 31.691c120.9 0 218.9 98 218.9 218.9s-98 218.9-218.9 218.9-218.93-98-218.93-218.9 98.03-218.9 218.93-218.9"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m253.04 7.86c-135.42 0-245.19 109.78-245.19 245.19 0 135.42 109.78 245.19 245.19 245.19 135.42 0 245.19-109.78 245.19-245.19 0-135.42-109.78-245.19-245.19-245.19m0 26.297c120.9 0 218.9 98 218.9 218.9s-98 218.9-218.9 218.9-218.93-98-218.93-218.9 98.03-218.9 218.93-218.9z",
    fill: "#fff",
    stroke: "#000",
    strokeOpacity: 0.31,
    strokeWidth: 4.904
  }))), _text151 || (_text151 = /*#__PURE__*/React.createElement("text", {
    x: 729.64,
    y: 231.36
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 729.64,
    y: 231.36
  }))), _text152 || (_text152 = /*#__PURE__*/React.createElement("text", {
    transform: "scale(4.0128 .2492)",
    x: 378.91,
    y: 579.26
  })), _text153 || (_text153 = /*#__PURE__*/React.createElement("text", {
    x: 1310.91,
    y: 151.36
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 1310.91,
    y: 151.36
  }))), _text154 || (_text154 = /*#__PURE__*/React.createElement("text", {
    transform: "scale(4.0128 .2492)",
    x: 523.76,
    y: 258.22
  })), _text155 || (_text155 = /*#__PURE__*/React.createElement("text", {
    x: 239.33,
    y: -29.9
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 239.33,
    y: -29.9
  }))), _text156 || (_text156 = /*#__PURE__*/React.createElement("text", {
    transform: "scale(4.0128 .2492)",
    x: 256.72,
    y: -469.13
  })), _text157 || (_text157 = /*#__PURE__*/React.createElement("text", {
    x: 1337.38,
    y: -246.37
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 1337.38,
    y: -246.37
  }))), _text158 || (_text158 = /*#__PURE__*/React.createElement("text", {
    transform: "scale(4.0128 .2492)",
    x: 530.36,
    y: -1337.8
  })), _text159 || (_text159 = /*#__PURE__*/React.createElement("text", {
    x: 1918.65,
    y: -326.37
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 1918.65,
    y: -326.37
  }))), _text160 || (_text160 = /*#__PURE__*/React.createElement("text", {
    transform: "scale(4.0128 .2492)",
    x: 675.21,
    y: -1658.83
  })), _text161 || (_text161 = /*#__PURE__*/React.createElement("text", {
    x: 1529.53,
    y: -798.77
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 1529.53,
    y: -798.77
  }))), _text162 || (_text162 = /*#__PURE__*/React.createElement("text", {
    transform: "scale(4.0128 .2492)",
    x: 578.24,
    y: -3554.48
  })), _text163 || (_text163 = /*#__PURE__*/React.createElement("text", {
    x: 2110.79,
    y: -878.78
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 2110.79,
    y: -878.78
  }))), _text164 || (_text164 = /*#__PURE__*/React.createElement("text", {
    transform: "scale(4.0128 .2492)",
    x: 723.09,
    y: -3875.52
  })), _text165 || (_text165 = /*#__PURE__*/React.createElement("text", {
    x: 277.99,
    y: 535.94
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 277.99,
    y: 535.94
  }))), _text166 || (_text166 = /*#__PURE__*/React.createElement("text", {
    x: 13.421,
    y: 260.32
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 13.421,
    y: 260.32
  }))), _text167 || (_text167 = /*#__PURE__*/React.createElement("text", {
    transform: "scale(4.0128 .2492)",
    x: 200.43,
    y: 695.45
  })), _text168 || (_text168 = /*#__PURE__*/React.createElement("text", {
    x: 594.69,
    y: 180.32
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 594.69,
    y: 180.32
  }))), _text169 || (_text169 = /*#__PURE__*/React.createElement("text", {
    transform: "scale(4.0128 .2492)",
    x: 345.27,
    y: 374.43
  })), _text170 || (_text170 = /*#__PURE__*/React.createElement("text", {
    x: -476.89,
    y: -0.942
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -476.89,
    y: -0.942
  }))), _text171 || (_text171 = /*#__PURE__*/React.createElement("text", {
    transform: "scale(4.0128 .2492)",
    x: 78.24,
    y: -352.93
  })), _text172 || (_text172 = /*#__PURE__*/React.createElement("text", {
    x: 621.16,
    y: -217.41
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 621.16,
    y: -217.41
  }))), _text173 || (_text173 = /*#__PURE__*/React.createElement("text", {
    transform: "scale(4.0128 .2492)",
    x: 351.87,
    y: -1221.6
  })), _text174 || (_text174 = /*#__PURE__*/React.createElement("text", {
    x: 1202.43,
    y: -297.42
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 1202.43,
    y: -297.42
  }))), _text175 || (_text175 = /*#__PURE__*/React.createElement("text", {
    transform: "scale(4.0128 .2492)",
    x: 496.72,
    y: -1542.63
  })), _text176 || (_text176 = /*#__PURE__*/React.createElement("text", {
    x: 813.31,
    y: -769.82
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 813.31,
    y: -769.82
  }))), _text177 || (_text177 = /*#__PURE__*/React.createElement("text", {
    transform: "scale(4.0128 .2492)",
    x: 399.75,
    y: -3438.29
  })), _text178 || (_text178 = /*#__PURE__*/React.createElement("text", {
    x: 1394.57,
    y: -849.82
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 1394.57,
    y: -849.82
  }))), _text179 || (_text179 = /*#__PURE__*/React.createElement("text", {
    transform: "scale(4.0128 .2492)",
    x: 544.6,
    y: -3759.31
  })), _text180 || (_text180 = /*#__PURE__*/React.createElement("text", {
    x: -438.23,
    y: 564.9
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -438.23,
    y: 564.9
  }))), _text181 || (_text181 = /*#__PURE__*/React.createElement("text", {
    x: 13.421,
    y: 260.32
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 13.421,
    y: 260.32
  }))), _text182 || (_text182 = /*#__PURE__*/React.createElement("text", {
    transform: "scale(4.0128 .2492)",
    x: 200.43,
    y: 695.45
  })), _text183 || (_text183 = /*#__PURE__*/React.createElement("text", {
    x: 594.69,
    y: 180.32
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 594.69,
    y: 180.32
  }))), _text184 || (_text184 = /*#__PURE__*/React.createElement("text", {
    transform: "scale(4.0128 .2492)",
    x: 345.27,
    y: 374.43
  })), _text185 || (_text185 = /*#__PURE__*/React.createElement("text", {
    x: -476.89,
    y: -0.942
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -476.89,
    y: -0.942
  }))), _text186 || (_text186 = /*#__PURE__*/React.createElement("text", {
    transform: "scale(4.0128 .2492)",
    x: 78.24,
    y: -352.93
  })), _text187 || (_text187 = /*#__PURE__*/React.createElement("text", {
    x: 621.16,
    y: -217.41
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 621.16,
    y: -217.41
  }))), _text188 || (_text188 = /*#__PURE__*/React.createElement("text", {
    transform: "scale(4.0128 .2492)",
    x: 351.87,
    y: -1221.59
  })), _text189 || (_text189 = /*#__PURE__*/React.createElement("text", {
    x: 1202.43,
    y: -297.42
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 1202.43,
    y: -297.42
  }))), _text190 || (_text190 = /*#__PURE__*/React.createElement("text", {
    transform: "scale(4.0128 .2492)",
    x: 496.72,
    y: -1542.62
  })), _text191 || (_text191 = /*#__PURE__*/React.createElement("text", {
    x: 813.31,
    y: -769.82
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 813.31,
    y: -769.82
  }))), _text192 || (_text192 = /*#__PURE__*/React.createElement("text", {
    transform: "scale(4.0128 .2492)",
    x: 399.75,
    y: -3438.27
  })), _text193 || (_text193 = /*#__PURE__*/React.createElement("text", {
    x: 1394.57,
    y: -849.82
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 1394.57,
    y: -849.82
  }))), _text194 || (_text194 = /*#__PURE__*/React.createElement("text", {
    transform: "scale(4.0128 .2492)",
    x: 544.6,
    y: -3759.29
  })), _text195 || (_text195 = /*#__PURE__*/React.createElement("text", {
    x: -438.23,
    y: 564.9
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -438.23,
    y: 564.9
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m130.8 114.88c-.307 8.335-.131 16.683-.178 25.02l38.432 38.432v191.7c-12.705.105-25.412.209-38.12.314-.052 8.662-.451 17.334-.039 25.988l69.14 69.14c16.973 4.221 34.725 6.475 53 6.475 108.05 0 197.81-78.29 215.67-181.24l-151.77-151.77c-1.034-1.034-2.111-2.036-3.232-3-21.13-17.823-50-22.13-76.81-20.594-30.06 1.22-60.25 8.844-90.29 2.668-5.317-.81-10.553-2.039-15.813-3.143",
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "m130.8 114.89c-.307 8.335-.131 16.683-.177 25.02 12.814 1.559 25.649 2.957 38.431 4.765v225.37c-12.705.105-25.411.21-38.12.315-.052 8.662-.452 17.333-.039 25.988 32.28 1.476 64.68.339 97.02.521l15.165-.048c.101-8.919.213-17.837.335-26.756h-44.751v-101.43h45.32c28.468 42.684 56.634 85.57 85.47 128.01 17.309.375 34.626-.171 51.937-.295-.122-8.663-.234-17.325-.335-25.988-11.34-.114-22.681-.239-34.02-.374-23.578-35.25-47.772-70.08-71.25-105.39 8.592-4.823 19.07-7.394 27.28-13.543 38.454-23.4 45.05-85.38 10.644-115.1-21.13-17.823-50-22.13-76.81-20.593-30.06 1.22-60.25 8.844-90.29 2.668-5.316-.81-10.553-2.039-15.812-3.142m113.56 26.48c21.335-.543 46.893 5.677 56.47 26.973 9.975 21.886 3.645 52-18.938 63.4-25.11 14.86-54.971 10.675-82.85 11.808-.891-6.271-.126-14.219-.381-21.13.083-25.97-.268-51.953.473-77.911 15.02-1.67 30.11-2.891 45.22-3.13",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRstudio);
export default __webpack_public_path__ + "static/media/rstudio.f9c7474f96c030049107f5123e276a8c.svg";
export { ForwardRef as ReactComponent };